import { motion } from 'framer-motion'
import { useInView } from './useInView'
import { Lightbulb, Target, Rocket } from 'lucide-react'

const values = [
  {
    icon: Lightbulb,
    title: 'Innowacja',
    description:
      'Laczymy wiedze technologiczna z pasja do sportu, tworzac rozwiazania ktore wyprzedzaja rynek.',
  },
  {
    icon: Target,
    title: 'Precyzja',
    description:
      'Kazdy element naszych produktow jest zaprojektowany z dbloscia o detale i doswiadczenie uzytkownika.',
  },
  {
    icon: Rocket,
    title: 'Skalowalnosc',
    description:
      'Budujemy technologie gotowe na wzrost - od lokalnych obiektow po ogolnopolskie sieci sportowe.',
  },
]

export default function About() {
  const { ref, isInView } = useInView()

  return (
    <section id="about" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 bg-radial-center" />

      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-20"
        >
          <p className="text-brand-400 font-semibold text-sm tracking-widest uppercase mb-4">
            O firmie
          </p>
          <h2 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight mb-6">
            Technologia spotyka
            <span className="text-gradient"> sport</span>
          </h2>
          <p className="text-lg text-zinc-400 leading-relaxed">
            Solid Labs PSA to krakowska firma technologiczna specjalizujaca sie w
            tworzeniu platform cyfrowych dla branzy sportowej. Naszym flagowym
            produktem jest Spotto - nowoczesna platforma do rezerwacji obiektow
            sportowych, zarzadzania treningami i laczenia sportowcow z
            trenerami.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {values.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 + i * 0.15 }}
              className="group relative p-8 rounded-2xl bg-white/[0.02] border border-white/[0.06] hover:border-white/[0.1] transition-all hover:bg-white/[0.04]"
            >
              <div className="w-12 h-12 rounded-xl bg-brand-600/10 flex items-center justify-center mb-6 group-hover:bg-brand-600/20 transition-colors">
                <item.icon size={24} className="text-brand-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
              <p className="text-zinc-400 leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
